/* import __COLOCATED_TEMPLATE__ from './workspace-security.hbs'; */
/* RESPONSIBLE TEAM: team-app-security */

import type AppService from 'embercom/services/app-service';
import Component from '@glimmer/component';
import { inject as service } from '@ember/service';
import type IntlService from 'ember-intl/services/intl';
import type Store from '@ember-data/store';
import { isValidEmail } from 'embercom/lib/email';

export interface WorkspaceSecurityArgs {
  settings: $TSFixMe;
  initialProvisioningMethod: string;
  selectedProvisioningMethod: string;
  showAllErrors: boolean;
  onProvisioningMethodUpdate: (provisioningMethod: string) => void;
}

export interface Signature {
  Element: HTMLDivElement;
  Args: WorkspaceSecurityArgs;
}

export default class WorkspaceSecurity extends Component<Signature> {
  @service declare appService: AppService;
  @service declare intl: IntlService;
  @service declare store: Store;
  @service declare intercomEventService: $TSFixMe;
  @service declare securityAppSettingsService: $TSFixMe;

  get app() {
    return this.appService.app;
  }

  get isInvalidSecurityEmail() {
    if (
      this.args.settings.securityContactEmail === '' ||
      this.args.settings.securityContactEmail === null
    ) {
      return false;
    }
    return !isValidEmail(this.args.settings.securityContactEmail);
  }

  get shouldShowSecurityContactWarningIcon() {
    if (
      this.args.settings.hasDirtyAttributes &&
      this.args.settings.changedAttributes().securityContactEmail
    ) {
      return this.args.settings.changedAttributes().securityContactEmail[0] === '';
    }
    return this.args.settings.securityContactEmail === '';
  }
}

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'NewSettings::Workspace::Security::Tabs::WorkspaceSecurity': typeof WorkspaceSecurity;
    'new-settings/workspace/security/tabs/workspace-security': typeof WorkspaceSecurity;
  }
}
